import axios from 'axios';
import config from '../config';

const { ruleServerUrl } = config;

export const upload = (formData: FormData) => {
  return axios
    .post<string[]>(`${ruleServerUrl}/users/upload/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res.data);
};

const toFormData = (files: Blob[]) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('images', file));
  return formData;
};

export const uploadFiles = (files: Blob[]) => upload(toFormData(files));

export const uploadFilesV2 = async (
  formData: FormData,
): Promise<{
  uploadedFiles: {
    url: string;
    id: string;
  }[];
}> => {
  return axios
    .post(
      `${ruleServerUrl}/users/storage/upload`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    )
    .then((res) => res.data);
};

export const getFileSignedUrl = async (fileId: string) => {
  return axios
    .get(
      `${ruleServerUrl}/users/storage/${fileId}`
    )
    .then((res) => res.data.url);
}

export type StorageBucketType = 'public' | 'private';

export const uploadFilesToStorage = (
  files: Blob[],
  folderPath: string,
  bucketType: StorageBucketType = 'public',
) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  formData.append('bucketType', bucketType);
  formData.append('folderPath', folderPath);
  return uploadFilesV2(formData).then(({ uploadedFiles }) =>
    (uploadedFiles || []).map((file) => file.url),
  );
};
